package learning.containers


import com.jingfangpai.api.clients.ContentApiClient
import react.*
import react.dom.div
import setTitle
import learning.components.GuideLines

external interface GuideLinesPageProps : RProps {

}

data class GuideLinesPageContextData(var query:(query:com.jingfangpai.content.model.ContentQuery, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.content.model.ContentVo>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit)

val GuideLinesPageContext = createContext(GuideLinesPageContextData(ContentApiClient::query))

val GuideLinesPageProvider = functionalComponent<GuideLinesPageProps> { props ->

    setTitle("中医学习指引")

    useEffectOnce { }

    GuideLinesPageContext.Provider(GuideLinesPageContextData(ContentApiClient::query)) {
        div("GuideLinesPage") {
            child(GuideLines) {

            }
        }
    }
}
